/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

/*
	* type组件类型，
	section:段落,
	text:正文文本,
	image:图片,
	annotation:, 注释文本
	video:视频,
	url:跳转链接, 
	plug: 充电点,
	vote:投票
*/
const { apiPath } = require('appService/api');
const ajaxHttp = require('appUtil/ajaxHttp');
const store = require('appVuex/store');

const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent,checkbox: checkboxEvent } = require('components/config/event.json');
const calendar = require('components/common/data-calendar/data-calendar');
const tip = require('components/base/pop/tip');
const template = require('./detailsComponents.tpl');
require('./detailsComponents.scss');

const paragraph = {
	template,
	store,
	vuex: {
		getters:{
			bannerImgs: (state) => state.detailsInfoImg.topicInfoImgs
		}
	},
	props:{
		type:{
			type:String,
			default:""
		},
    idx:{
      type:Number,
      default:0
    },
		headTit:{
				type:String,
				default:"添加段落标题"
		},
		headTitLess:{
				type:String,
				default:"添加段落副标题"
		},
    detailData:{
      type:Object,
      default: () => {
      	optionLimit:2
      }
    },
    imgsuccess:{
    	type:Function
    }
	},
	data() {
		return {
			uploadImg: apiPath.common.uploadImg,
			spotInfoUrl: apiPath.community.spotInfo,
      now: this.formatDate(new Date().getTime()),
			"linkDesc":0,
			"hasVideo":0, //是否已生成视频链接
			"option":this.detailData.option || [
				{'name':'','total':0,'totalPercent':0},
				{'name':'','total':0,'totalPercent':0}
			],
			"optionType":1,
			"chargerId":'',
			//bannerImgs:JSON.parse(sessionStorage.getItem('bannerImgs')) || {},
			video_url:"",
			videoUrl:"",
			spotId:"",
			spotData:this.detailData,
			isEmpty:true,
			/*spotData:{
				"isFree":1,
				"name":"测试专用点",
				"score":6.9,
				"spotType":1,
			},*/
			spotTypeList:['未知','慢速','快速','','超速']
		}
	},
	ready(){
		//console.log(this.bannerImgs['188766805060223040']);	
	},
	computed:{
		isvideoLink(){
			let regx=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
			return regx.test(this.videoUrl);
		},
		startHalf(){
			let _s = ''+this.spotData.score;
			/*let _f = typeof _s.split(".")[1] != 'undefined';
			console.log(_f);*/
			return (typeof _s.split(".")[1] != 'undefined') && (_s.split(".")[1]*1>0)
		}
	},
	methods:{
    formatDate: function (time) {
      let dTime = new Date(time);
      return `${dTime.getFullYear()}-${dTime.getMonth() + 1}-${dTime.getDate()}`;
    },
    uploadSuccess(opt,pt){
    	console.log(222222222222223);
    	this.imgsuccess && this.imgsuccess.call(null, opt, pt)
    	//this.$emit('imgsuccess',opt,pt);

    },
    formatVideoUrl(url){
      let videoColl = {
        qq:'http://v.qq.com/iframe/player.html?vid=',
        youku:'http://player.youku.com/embed/'
      }
      if(url.indexOf('v.qq') != -1){
        let s = url.lastIndexOf("/")+1;
        let e = url.lastIndexOf(".");
        let vid = url.substring(s,e);
        this.video_url = videoColl.qq+vid
      }else if(url.indexOf('youku') != -1){
        let _url = url.split("id_")[1].split('==')[0]+'==';
        this.video_url = videoColl.youku+_url;
      }else{
        this.video_url = url;
      }
    },
    previewVideo(){
    	this.hasVideo = true;
    	this.formatVideoUrl(this.videoUrl);
    	//this.video_url = this.videoUrl;
    },
    getSpotInfo(){
    	if(this.spotId==""){

    		tip("请输入充电点ID");
    		return;
    	}
    	ajaxHttp(this.spotInfoUrl,{
          data:{
            spotId:this.spotId
            }
          })
          .then((rtn) => {
          	//this.spotCg = true;
            this.spotData =rtn.data;
            console.log(this.spotData.name);
            }).catch((rtn) => {
              tip(rtn.message||'您要查询的充电点不存在')
          })
    }
	},
	events:{
		[inputBoxEvent.change](obj){
					let _qn = obj.queryName;
					if(_qn.indexOf("video") != -1){
							this.videoUrl = obj.value;
							return;
					}
					if(_qn.indexOf('optionLimit') != -1){
							this.$refs.optionlimit.value = obj.value> this.option.length? this.option.length: obj.value<1? 1: obj.value;
					}
					if(_qn.indexOf('spotId') != -1){
							this.spotId = obj.value;
							this.spotData = {};
					}
					if(_qn.indexOf('link') != -1){

						this.isEmpty = (obj.value != "")? false : true;
					}
					
          //console.log(obj);
    },
    [checkboxEvent.change](obj) {
    	let _qn = obj.queryName;
    	if(_qn.indexOf('optionType')!= -1){
    		this.optionType = obj.value;
    	}
    }
	},
	watch:{

	}
}

module.exports = paragraph;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/details-topic/detailsComponents/detailsComponents.js